<template>
  <div class="container">
    <div class="img">
      <img src="../assets/404@2x.png" width="728px" height="316px" alt="" />
      <p>
        网页丢失了…
      </p>
      <div class="btn" @click="$router.push({ path: '/' })">返回首页</div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  position: relative;
  .img {
    width: 728px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    p {
      font-size: 20px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      color: rgba(128, 124, 124, 1);
      line-height: 30px;
      text-align: center;
      margin-top: 73px;
    }
    .btn {
      cursor: pointer;
      width: 187px;
      height: 40px;
      background: linear-gradient(
        137deg,
        rgba(255, 83, 132, 1) 0%,
        rgba(255, 39, 39, 1) 100%
      );
      margin: 80px auto 0;

      border-radius: 10px;
      font-size: 20px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/404.vue